import API from 'services/API';

/** Liste les pièces jointes d'un vol. */
export const list = flightId => API.get(`/flight/${flightId}/attachment`);

/**
 * Envoie un ou plusieurs fichiers.
 * Ne PAS fixer manuellement le Content-Type : axios le supprime pour un
 * FormData et le navigateur ajoute le boundary multipart.
 */
export const upload = (flightId, files) => {
  const formData = new FormData();
  Array.from(files).forEach(file => formData.append('files', file));
  return API.post(`/flight/${flightId}/attachment`, formData);
};

/** Télécharge une pièce jointe (blob). */
export const download = (flightId, attachmentId) =>
  API.get(`/flight/${flightId}/attachment/${attachmentId}`, { responseType: 'blob' });

/** Télécharge toutes les pièces jointes du vol dans un zip `flight_<id>.zip`. */
export const downloadZip = flightId =>
  API.get(`/flight/${flightId}/attachment/zip`, { responseType: 'blob' });

/** Supprime une pièce jointe. */
export const remove = (flightId, attachmentId) =>
  API.delete(`/flight/${flightId}/attachment/${attachmentId}`);
